import React from 'react';
import PropTypes from 'prop-types';
import {FileUpload} from '@/components/atoms';

const CustomFileUploadController = (props) => {
  /**
   * @typedef {Object} Props
   * @property {function} handleChange - Function to handle changes in the file upload.
   * @property {string} label - Label for the file upload input.
   * @property {Object} data - Data related to the file upload.
   * @property {string} path - Path where the file will be uploaded.
   * @property {Object} errors - Errors related to the file upload.
   * @property {Object} schema - Schema for the file upload.
   * @property {Object} uischema - UI schema for the file upload.
   * @property {boolean} required - Indicates if the file upload is required.
   */
  const {handleChange, label, data, path, errors, schema, uischema, required} =
    props;
  return (
    <FileUpload
      value={data}
      label={label}
      updateValue={(newVal) => handleChange(path, newVal)}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
    />
  );
};

CustomFileUploadController.propTypes = {
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  data: PropTypes.any,
  path: PropTypes.string.isRequired,
  errors: PropTypes.object,
  schema: PropTypes.object.isRequired,
  uischema: PropTypes.object,
  required: PropTypes.bool
};

export default React.memo(CustomFileUploadController);
